import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Button2 from "../button/Button2";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import axios from "../../API/axios";
import moment from "moment/moment";
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import { Height } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";


Job05.propTypes = {};

function Job05() {
  // const { data } = props;
  const token = localStorage.getItem('token')

  // ...............................All Job List.......................................

  const [jobList, setjobList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getAlljobList = (page) => {
    setIsLoading(true);
    const data = {
      pageNumber: page,
      pageSize: 10,
    };

    axios
      .get(`/Job/GetFeaturedJobs`, data)
      .then((response) => {
        const res = response.data.responseData;
        // console.log("getAlljobList", response.data.responseData);
        setjobList(res);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error)
      });
  };

  useEffect(() => {
    getAlljobList(); // Initial fetch on mount
  }, []);

  // ...............................All Jobs List.......................................

  // ..............................................................

  // Money Format at Code Language Start
  const formatSalary = (salary) => {
    if (salary >= 10000000) {
      return (salary / 10000000).toFixed(1) + 'Cr'; // 'Cr' for crore
    } else if (salary >= 100000) {
      return (salary / 100000).toFixed(1) + 'L'; // 'L' for lakh (includes 10L for 1M)
    } else if (salary >= 1000) {
      return (salary / 1000).toFixed(1) + 'k'; // 'k' for thousand
    } else {
      return salary; // Return as is for values less than 1000
    }
  };

  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;

    const anchors = div.querySelectorAll('a');
    anchors.forEach(anchor => {
      anchor.setAttribute('target', '_blank');
      anchor.setAttribute('rel', 'noopener noreferrer');
    });

    return div.innerHTML;
  };


  const linkifyContent = (htmlContent) => {
    const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

  return (


    <>
      {jobList.length === 0 ? '' :
        <section className=" container nonloginFeature">
          <Tabs className="wrap-testimonials style-1 over-flow-hidden tf-tab">
            <div className="container">
              <div className="tf-title style-3 margin">
                <div className="group-title">
                  <h1>Featured Jobs</h1>
                  <p>Find the right career opportunity for you</p>
                </div>

              </div>
              <div className="content-tab">
                <TabPanel className="row wow fadeInUp animation-tab job-tab-item">
                  <div className="group-col-4 Featured-Job-Section p-0">

                    {jobList?.map((data) => (
                      console.log('data', data),
                      <div key={data.id} className="col-lg-4 col-md-6 Featured-Jobs-Cards">
                        <Link
                          to={`/job/${data.jobId}`}
                        >
                          <div className="features-job new-feature-job"  >
                            <div className="job-archive-header">
                              <div className="inner-box">
                                <div className="logo-company">
                                  <img src={data.compImage} alt="User Logo" />
                                </div>
                                <div className="box-content">
                                  <h4 className="mb-0">
                                    {
                                      data.compType === "Company" ? (
                                        <>
                                          <div className="d-flex justify-content-between">
                                            <div className="line">
                                              <Link to={`/Company/${data.compUid}`}>{data.compName}
                                              </Link>
                                            </div>
                                            <div className="row">
                                              <span className="f-16 d-flex align-center p-0 feature-job-bag-svg">
                                                <WorkSharpIcon className="f-18   me-2" />
                                                {data.jobAppliedCount}</span>
                                            </div>
                                          </div></>
                                      ) : (
                                        <>
                                          <div className="d-flex justify-content-between">
                                            <div className="line">
                                              <Link to={`/Recruiter/${data.compUid}`}>{data.compName}
                                              </Link>
                                              <span className="rec-badge-purple ms-2">{data.compType}</span>
                                            </div>
                                            <div className="row">
                                              <p className=" d-flex align-center p-0 mb-0" style={{ color: "GrayText" }}>
                                                <WorkSharpIcon className="f-18" />
                                                {data.jobAppliedCount}</p>
                                            </div>
                                          </div>
                                        </>
                                      )
                                    }
                                  </h4>
                                  <h3 className="mb-0 d-flex justify-content-between">
                                    <Link to={`/job/${data.jobId}`}> {data.title} </Link>


                                  </h3>
                                  <ul className="p-0">
                                    <li>
                                      <span className="icon-map-pin"></span>
                                      &nbsp;
                                      {data.cityName}
                                    </li>
                                    <li>
                                      <span className="icon-calendar"></span>
                                      &nbsp;
                                      {moment
                                        .utc(data.creationTime)
                                        .local()
                                        .format("DD MMMM YYYY")}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <p className="short-content short-content-jobcard"
                                dangerouslySetInnerHTML={{
                                  __html: linkifyContent(
                                    addTargetBlankToAnchors(data.shortDescription.replace(/●/g, ''))
                                  )
                                }}

                              >
                                {/* {data.shortDescription} */}
                              </p>
                            </div>
                            <div className="job-archive-footer">
                              <div className="job-footer-left ">
                                <ul className="job-tag Job-Footer-Small-Button">
                                  {data.jbTypName === "" || data.jbTypName === null ? "" : (
                                    <li>
                                      <Link
                                        style={{ pointerEvents: "none" }}
                                        onClick={(e) => e.preventDefault()}
                                        to="#/">{data.jbTypName}</Link>
                                    </li>
                                  )}
                                  {data.workLevelTypename === "" || data.workLevelTypename === null ? "" : (
                                    <li>
                                      <Link
                                        style={{ pointerEvents: "none" }}
                                        onClick={(e) => e.preventDefault()}
                                        to="#/">{data.workLevelTypename}</Link>
                                    </li>
                                  )}
                                  {data.workLocationTypeName === "" || data.workLocationTypeName === null ? "" : (
                                    <li>
                                      <Link
                                        style={{ pointerEvents: "none" }}
                                        onClick={(e) => e.preventDefault()}
                                        to="#/">{data.workLocationTypeName}</Link>
                                    </li>
                                  )}
                                  {data.designationName === "" || data.designationName === null ? "" : (
                                    <li>
                                      <Link
                                        style={{ pointerEvents: "none" }}
                                        onClick={(e) => e.preventDefault()}
                                        to="#/">{data.designationName}</Link>
                                    </li>
                                  )}
                                </ul>
                              </div>
                              <div className="job-footer-right job-footer-right-price">
                                <div className="price nonlogin-price">
                                  {/* <span className="icon-dolar1"></span> */}
                                  <p className="mb-0">
                                    <span style={{ paddingRight: "2px" }} className="currencycapitalized">
                                      {data.currency}
                                    </span>
                                    {formatSalary(data.maxSalary)}
                                    {/* {data.salaryTypeName} */}

                                    <Tooltip title={data.salaryTypeName} arrow>
                                      <span className="year"
                                        onClick={(e) => e.preventDefault()}>
                                        {/* /{idx.salaryTypeName} */}
                                        /{data.salaryTypeName.includes("Annual Salary") ? "Annual Salary.." : data.salaryTypeName}
                                      </span>
                                    </Tooltip>
                                    <span className="year"></span>
                                  </p>
                                </div>
                                <p className="days mb-0">{data.apply}</p>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}

                  </div>
                  <div className="col-md-12">
                    <div className="wrap-button d-flex justify-content-center">
                      {/* <Button2 title="See more Jobs" link="/joblist_v1" /> */}
                      <div className="khojPrimaryBtn1 ms-3" style={{ width: '150px' }}>
                        <Link to="/Jobs" className="">See More Jobs</Link>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                {/* <TabPanel className="row wow fadeInUp animation-tab job-tab-item">
              {data.slice(0, 6).map((idx) => (
                <div key={idx.id} className="col-lg-6 ">
                  <div className="features-job">
                    <div className="job-archive-header">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={idx.img} alt="User Logo" />
                        </div>
                        <div className="box-content">
                          <h4>
                            <Link to="/jobDetails">{idx.cate}</Link>
                          </h4>
                          <h3>
                            <Link to="/jobDetails"> {idx.title} </Link>
                            <span className="icon-bolt"></span>
                          </h3>
                          <ul>
                            <li>
                              <span className="icon-map-pin"></span>
                              &nbsp;
                              {idx.map}
                            </li>
                            <li>
                              <span className="icon-calendar"></span>
                              &nbsp;
                              {idx.time}
                            </li>
                          </ul>
                          <span className="icon-heart"></span>
                        </div>
                      </div>
                    </div>
                    <div className="job-archive-footer">
                      <div className="job-footer-left">
                        <ul className="job-tag">
                          <li>
                            <Link to="#">{idx.jobs1}</Link>
                          </li>
                          <li>
                            <Link to="#">{idx.jobs2}</Link>
                          </li>
                        </ul>
                        <div className="star">
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                        </div>
                      </div>
                      <div className="job-footer-right">
                        <div className="price">
                          <span className="icon-dolar1"></span>
                          <p>
                            {idx.price}
                            <span className="year">/year</span>
                          </p>
                        </div>
                        <p className="days">{idx.apply}</p>
                      </div>
                    </div>
                    <Link
                      to="/jobDetails"
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link>
                  </div>
                </div>
              ))}
              <div className="col-md-12">
                <div className="wrap-button">
                  <Button2 title="See more Jobs" link="/joblist_v1" />
                </div>
              </div>
            </TabPanel>
            <TabPanel className="row wow fadeInUp animation-tab job-tab-item">
              {data.slice(0, 6).map((idx) => (
                <div key={idx.id} className="col-lg-6 ">
                  <div className="features-job">
                    <div className="job-archive-header">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={idx.img} alt="User Logo" />
                        </div>
                        <div className="box-content">
                          <h4>
                            <Link to="/jobDetails">{idx.cate}</Link>
                          </h4>
                          <h3>
                            <Link to="/jobDetails"> {idx.title} </Link>
                            <span className="icon-bolt"></span>
                          </h3>
                          <ul>
                            <li>
                              <span className="icon-map-pin"></span>
                              &nbsp;
                              {idx.map}
                            </li>
                            <li>
                              <span className="icon-calendar"></span>
                              &nbsp;
                              {idx.time}
                            </li>
                          </ul>
                          <span className="icon-heart"></span>
                        </div>
                      </div>
                    </div>
                    <div className="job-archive-footer">
                      <div className="job-footer-left">
                        <ul className="job-tag">
                          <li>
                            <Link to="#">{idx.jobs1}</Link>
                          </li>
                          <li>
                            <Link to="#">{idx.jobs2}</Link>
                          </li>
                        </ul>
                        <div className="star">
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                        </div>
                      </div>
                      <div className="job-footer-right">
                        <div className="price">
                          <span className="icon-dolar1"></span>
                          <p>
                            {idx.price}
                            <span className="year">/year</span>
                          </p>
                        </div>
                        <p className="days">{idx.apply}</p>
                      </div>
                    </div>
                    <Link
                      to="/jobDetails"
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link>
                  </div>
                </div>
              ))}
              <div className="col-md-12">
                <div className="wrap-button">
                  <Button2 title="See more Jobs" link="/joblist_v1" />
                </div>
              </div>
            </TabPanel>
            <TabPanel className="row wow fadeInUp animation-tab job-tab-item">
              {data.slice(0, 6).map((idx) => (
                <div key={idx.id} className="col-lg-6 ">
                  <div className="features-job">
                    <div className="job-archive-header">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={idx.img} alt="User Logo" />
                        </div>
                        <div className="box-content">
                          <h4>
                            <Link to="/jobDetails">{idx.cate}</Link>
                          </h4>
                          <h3>
                            <Link to="/jobDetails"> {idx.title} </Link>
                            <span className="icon-bolt"></span>
                          </h3>
                          <ul>
                            <li>
                              <span className="icon-map-pin"></span>
                              &nbsp;
                              {idx.map}
                            </li>
                            <li>
                              <span className="icon-calendar"></span>
                              &nbsp;
                              {idx.time}
                            </li>
                          </ul>
                          <span className="icon-heart"></span>
                        </div>
                      </div>
                    </div>
                    <div className="job-archive-footer">
                      <div className="job-footer-left">
                        <ul className="job-tag">
                          <li>
                            <Link to="#">{idx.jobs1}</Link>
                          </li>
                          <li>
                            <Link to="#">{idx.jobs2}</Link>
                          </li>
                        </ul>
                        <div className="star">
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                        </div>
                      </div>
                      <div className="job-footer-right">
                        <div className="price">
                          <span className="icon-dolar1"></span>
                          <p>
                            {idx.price}
                            <span className="year">/year</span>
                          </p>
                        </div>
                        <p className="days">{idx.apply}</p>
                      </div>
                    </div>
                    <Link
                      to="/jobDetails"
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link>
                  </div>
                </div>
              ))}
              <div className="col-md-12">
                <div className="wrap-button">
                  <Button2 title="See more Jobs" link="/joblist_v1" />
                </div>
              </div>
            </TabPanel>
            <TabPanel className="row wow fadeInUp animation-tab job-tab-item">
              {data.slice(0, 6).map((idx) => (
                <div key={idx.id} className="col-lg-6 ">
                  <div className="features-job">
                    <div className="job-archive-header">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={idx.img} alt="User Logo" />
                        </div>
                        <div className="box-content">
                          <h4>
                            <Link to="/jobDetails">{idx.cate}</Link>
                          </h4>
                          <h3>
                            <Link to="/jobDetails"> {idx.title} </Link>
                            <span className="icon-bolt"></span>
                          </h3>
                          <ul>
                            <li>
                              <span className="icon-map-pin"></span>
                              &nbsp;
                              {idx.map}
                            </li>
                            <li>
                              <span className="icon-calendar"></span>
                              &nbsp;
                              {idx.time}
                            </li>
                          </ul>
                          <span className="icon-heart"></span>
                        </div>
                      </div>
                    </div>
                    <div className="job-archive-footer">
                      <div className="job-footer-left">
                        <ul className="job-tag">
                          <li>
                            <Link to="#">{idx.jobs1}</Link>
                          </li>
                          <li>
                            <Link to="#">{idx.jobs2}</Link>
                          </li>
                        </ul>
                        <div className="star">
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                        </div>
                      </div>
                      <div className="job-footer-right">
                        <div className="price">
                          <span className="icon-dolar1"></span>
                          <p>
                            {idx.price}
                            <span className="year">/year</span>
                          </p>
                        </div>
                        <p className="days">{idx.apply}</p>
                      </div>
                    </div>
                    <Link
                      to="/jobDetails"
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link>
                  </div>
                </div>
              ))}
              <div className="col-md-12">
                <div className="wrap-button">
                  <Button2 title="See more Jobs" link="/joblist_v1" />
                </div>
              </div>
            </TabPanel> */}
              </div>
            </div>
          </Tabs >
        </section >}
    </>
  );
}

export default Job05;
